export const iconFontAwesomeEducationSchoolLock = (
	<i className="fa-solid fa-school-lock"></i>
);
